/* @flow */

import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Form, Message } from 'semantic-ui-react';
import { getSettings, getUnlockedTemplates } from 'catalog/reducers/catalog';
import TemplateSelector from './TemplateSelector';
import NetworkModeSelector from './NetworkModeSelector';
import SecurityContextSelector from './SecurityContextSelector';

type Props = {
  children: (params: any) => Element,
  submitting: boolean,
  error?: string,
  pristine?: boolean,
  history: Object,
  location: Object,
  settings: CatalogSettings,
  templates: Array<CatalogTemplate>,
  handleSubmit: () => void,
  onSubmit: (values: Object, dispatch: Function, props: Object) => void,
};

const styles = {
  form: {
    marginTop: '1rem',
  },
};

const isRootLocation = location => location.query && location.query.root;
const defaultNameIfRoot = location =>
  (isRootLocation(location) ? 'Accueil' : '');

const mapStateToProps = (state, { location }) => {
  const settings = getSettings(state);

  return {
    initialValues: {
      root: isRootLocation(location),
      name: defaultNameIfRoot(location),
      networkMode: settings.defaultNetworkMode,
      securityContext: settings.defaultSecurityContext || 'none',
    },
    settings,
    templates: getUnlockedTemplates(state),
  };
};

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Le nom est requis';
  }
  if (!values.template) {
    errors.template = 'Le type est requis';
  }

  return errors;
};

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <Form.Field error={touched && !!error}>
    <label>{label}</label>
    <input {...input} placeholder={label} type={type} />
  </Form.Field>
);

const Create = ({
  children,
  settings,
  templates,
  pristine,
  submitting,
  error,
  history,
  location,
  handleSubmit,
  onSubmit,
}: Props) => {
  const renderFields = () => {
    return (
      <div>
        <Message error content={error} />
        <Field name="root" type="hidden" component="input" />
        <Field
          name="name"
          type="text"
          component={renderField}
          label="Nom de la page"
        />
        <Field
          name="template"
          component={TemplateSelector}
          label="Type"
          templates={templates}
        />
        <Field
          name="networkMode"
          component={NetworkModeSelector}
          label="Mode de connectivité"
          canOverride={settings.canOverrideNetworkMode}
        />
        <Field
          name="securityContext"
          component={SecurityContextSelector}
          label={`Contexte d'authentification`}
          canOverride={settings.canOverrideSecurityContext}
        />
      </div>
    );
  };

  return (
    <Form error={!!error} onSubmit={handleSubmit} style={styles.form}>
      {children({
        fields: renderFields(),
        pristine,
        submitting,
      })}
    </Form>
  );
};

export default compose(
  withRouter,
  connect(mapStateToProps),
  reduxForm({
    form: 'createPage',
    validate,
  })
)(Create);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/CreatePageForm.js